import { setObjectValue } from "../utils/utils.js";
import { getCourtData } from "../courts/BankruptcyCourts.js";
import { Conditions } from "./conditions";
import Vue from "vue";
import { getObjectValue } from "../utils/utils.js";
import { pushObjectValue } from "../utils/utils.js";
import { removeObjectValue } from "../utils/utils.js";
import { getBankruptcyCourtForSelect } from "../courts/BankruptcyCourts";

var loaded_postal_code = null;
var loaded_province = null;
var loaded_region = null;
var selected_autocomplete = null;
var changing_name = null;
var autocomplete_list = [];

export function set_autocomplete_list(new_list) {
  autocomplete_list = new_list;
}

function AddObjectOfFieldsToList(config, model) {
  var list_of_items = getObjectValue(model, config.field);
  config.items.forEach(element => {
    for (const [key, value] of Object.entries(element)) {
      var new_value;
      if (value.includes(".")) {
        // check if attribute value is path
        new_value = getObjectValue(model, value);
        element[key] = new_value;
      }
    }
    if (
      element["value"] != null &&
      !list_of_items.some(e => e.name === element["name"]) &&
      element["value"].length > 0
    ) {
      pushObjectValue(model, element, config.field);
    } else if (
      list_of_items.some(e => e.name === element["name"]) &&
      element["value"].length == 0
    ) {
      var index = list_of_items.findIndex(e => e.name === element["name"]);
      if (index >= 0) removeObjectValue(model, config.field, index);
    } else if (
      list_of_items.some(e => e.name === element["name"]) &&
      list_of_items.some(e => e.value != element["value"])
    ) {
      index = list_of_items.findIndex(e => e.name === element["name"]);
      removeObjectValue(model, config.field, index);
      pushObjectValue(model, element, config.field);
    }
  });
}

// add object to list if conditions are valid
function AddObjectToListByConditions(config, model) {
  var list_of_items = getObjectValue(model, config.field);
  config.items.forEach(element => {
    var conditions = new Conditions(element.add_if, model);
    var index = list_of_items.findIndex(e => e.name === element.object["name"]);
    var valid_conditions = conditions.is_all_valid;
    if (valid_conditions && index < 0) {
      pushObjectValue(model, element.object, config.field);
    } else if (!valid_conditions && index >= 0) {
      removeObjectValue(model, config.field, index);
    }
  });
}

// set object value by getting user data
function FillUserData(config, model, field) {
  var value = getObjectValue(model, field);
  if (value === null) {
    Vue.CognitoAuth.get_current_user_data().then(function(user_data) {
      setObjectValue(model, user_data[config.value], field);
    });
  }
}

// set object value by getting court data
function FillCourt(config, model, field) {
  var court_name = getObjectValue(model, config.court);
  var court_data = getCourtData(court_name);
  if (court_data != null) {
    setObjectValue(model, court_data[config.value], field);
  }
}

// set default object value
function FillField(config, model, field) {
  var value = getObjectValue(model, field);
  if (value === null) {
    if (typeof config.is_model != "undefined" && config.is_model == true) {
      setObjectValue(model, getObjectValue(model, config.value), field);
    } else {
      setObjectValue(model, config.value, field);
    }
  }
}
// function start when schema changed
async function FillCourtList(config, model, field) {
  var value = getObjectValue(model, field);
  var province = getObjectValue(model, config.province);
  var postal_code = getObjectValue(model, config.postal_code);
  var region = getObjectValue(model, config.region);

  if (value === null || postal_code !== loaded_postal_code || province !== loaded_province || region !== loaded_region) {
    let selected_court = await getBankruptcyCourtForSelect(province, postal_code, region);
    setObjectValue(model, selected_court, field);
    loaded_province = province;
    loaded_postal_code = postal_code;
    loaded_region = region;
  }
}

// function start when user select option in autocomplete
function FillAutocomplete(config, model, field) {
  // get value from autocomplete field to search data to fill
  var name = getObjectValue(model, config.field);
  var field_value = getObjectValue(model, field);
  // find object from full autocomplete list by name
  if (autocomplete_list != null) {
    var result = autocomplete_list.filter(obj => {
      return obj.name === name;
    });
  }
  if (
    name == selected_autocomplete &&
    (field_value == null || field_value == "")
  ) {
    selected_autocomplete = null; // set selected_autocomplete to null for fillup field again
  }
  if (name != selected_autocomplete) {
    // if full autocomplete list is not empty and name is set
    if (name != null && result.length > 0) {
      setObjectValue(model, result[0][config.value], field);
      selected_autocomplete = name;
    }
  }
}

function FillFieldOnChange(config, model, field) {
  var value = getObjectValue(model, field);
  if (value != changing_name) {
    config.fields.forEach(function(element) {
      setObjectValue(model, null, element);
    });
    changing_name = value;
  }
}

function FillReason(config, model) {
  Vue.Backend.generate_reason(model, Vue.CognitoAuth.session.id_token).then(
    function(response) {
      config.fields.forEach(function(field) {
        var value = getObjectValue(model, field);
        if (response.data.result[field] != value) {
          setObjectValue(
            model,
            response.data.result[field],
            config.path + field
          );
        }
      });
    }
  );
}

// class to call functions by fill_data name
export class FillInTheField {
  constructor(config, model) {
    this.field = config.model;
    this.model = model;
    this.config = config;

    var $this = this;
    if (this.config) {
      this.config.fill_data.forEach(function(fill_data_config) {
        $this.get_FillField_class(fill_data_config, $this.model, $this.field);
      });
    }
  }
  get_FillField_class(config, model, field) {
    if (config.name == "fill_court") {
      FillCourt(config, model, field);
    } else if (config.name == "fill_user_data") {
      FillUserData(config, model, field);
    } else if (config.name == "fill_field") {
      FillField(config, model, field);
    } else if (config.name == "fill_court_list") {
      FillCourtList(config, model, field);
    } else if (config.name == "fill_field_on_change") {
      FillFieldOnChange(config, model, field);
    } else if (config.name == "fill_autocomplete") {
      FillAutocomplete(config, model, field);
    } else if (config.name == "add_object_of_fields_to_list") {
      AddObjectOfFieldsToList(config, model);
    } else if (config.name == "fill_reason") {
      FillReason(config, model);
    } else if (config.name == "add_object_to_list_by_conditions") {
      AddObjectToListByConditions(config, model);
    }
  }
}
